import { DataTable } from "../../data-table.interface";

export const massiveProductCancellation: DataTable = {
  hasDisabledInput: (element: any): boolean => {
    return element['canceled']
    || element['originType']==='PRV'
    || (element['payState'] === 'PAYMENT_PENDING')
    ;
  },
  columns: [
    {
      title: 'Nª de NV',
      name: 'saleNoteId',
      type: 'string',
      editable: false,
      align: 'center',
      value: (element: any) => element.saleNoteId
    },
    {
      title: 'Nª de despacho',
      name: 'dispatchId',
      type: 'string',
      editable: false,
      align: 'center',
      value: (element: any) => element.dispatchId
    },
    {
      title: 'SKU',
      name: 'skuCode',
      type: 'string',
      editable: false,
      align: 'center',
      value: (element: any) => element.dispatchItems.skuCode
    },
    {
      title: 'Descripción',
      name: 'description',
      type: 'string',
      editable: false,
      align: 'left',
      value: (element: any) => element.dispatchItems.skuName
    },
    {
      title: 'Cant. Disponible',
      name: 'availableItems',
      type: 'string',
      editable: false,
      align: 'center',
      value: (element: any) => element.availableItems
    },
    {
      title: 'Cant. a eliminar',
      name: 'canceledItems',
      type: 'number',
      editable: true,
      align: 'center',
      value: (element: any) => {
        return { num: element.canceledItems, min: 1, max: element.availableItems }
      }
    },
    {
      title: 'Motivo de anulación',
      name: 'reasonCancellation',
      type: 'select',
      editable: true,
      class: 'center',
      placeholderHidden: true,
      value: (element: any) =>  element.listMotive //Constants.SaleNote.GUIDE_TRAVEL.getProps()
    }
  ]
};

